import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class PaymentOrderList  {
    _originalTypeClassName = "zERP.BO.PaymentOrderList";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
PaymentOrderList.translate = translateService;
}
this.PaymentOrders = [];
this.Budget = new Domain.Budget();
this.Entity = new Domain.BusinessEntity();
this.Id = null;
this.Notes = null;
this.DateCreated = null;
this.PayableAmount = null;
this.Status = null;
this.SystemDateApproved = null;
this.DateApproved = null;
this.ApprovalReference = null;
this.Type = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Notes:any;
DateCreated:any;
PayableAmount:any;
Status:any;
SystemDateApproved:any;
DateApproved:any;
ApprovalReference:any;
Type:any;
PaymentOrders:any;
Owner:any;
CurrentStep:any;
CreatedBy:any;
Budget:any;
Entity:any;
ApprovedBy:any;
static setPaymentOrders = ($this, items) => {
                if (items == null) items = [];
                if ($this.PaymentOrders == null) $this.PaymentOrders = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PaymentOrders.length > 0) {
                    Domain.PaymentOrderList.removePaymentOrders($this, $this.PaymentOrders[0]);
                }

                Domain.PaymentOrderList.addManyPaymentOrders($this, copyItems);
            }
static addManyPaymentOrders = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.PaymentOrderList.addPaymentOrders($this, items[i]);
                }
            }
static addPaymentOrders = ($this, item) => {
                if ($this.PaymentOrders == null) $this.PaymentOrders = [];
                if (item == null || $this.PaymentOrders.indexOf(item) > -1) return;
                $this.PaymentOrders.push(item);
if (item.PaymentOrderList != $this) {
Domain.PaymentOrder.setPaymentOrderList(item, $this);
}
}
static addRangePaymentOrders = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.PaymentOrderList.addPaymentOrders($this, item));
            }
static removePaymentOrders = ($this, item) => {
                if ($this == null || $this.PaymentOrders == null || $this.PaymentOrders.indexOf(item) === -1) return;
                var _index = $this.PaymentOrders.indexOf(item);
                $this.PaymentOrders.splice(_index, 1);
item.PaymentOrderList = null;
}
static clearPaymentOrders = ($this) => { $this.PaymentOrders = null; }
static setOwner = ($this, value) => {
var oldValue = $this.Owner;
$this.Owner = value;
if (value != null) {
}
}
static setCurrentStep = ($this, value) => {
var oldValue = $this.CurrentStep;
$this.CurrentStep = value;
if (value != null) {
}
}
static setCreatedBy = ($this, value) => {
var oldValue = $this.CreatedBy;
$this.CreatedBy = value;
if (value != null) {
}
}
static setBudget = ($this, value) => {
var oldValue = $this.Budget;
$this.Budget = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setApprovedBy = ($this, value) => {
var oldValue = $this.ApprovedBy;
$this.ApprovedBy = value;
if (value != null) {
}
}

static GetClassName(): any{return "PaymentOrderList";
}
static IsViewMode($this: any): any{if (Domain.PaymentOrderList.IsNew($this)) {return false;}
if ($this?.Status == Domain.BudgetStatus.Approved || $this?.Status == Domain.BudgetStatus.Canceled || $this?.Status == Domain.BudgetStatus.Rejected) {return true;}
if ($this?.CurrentStep != null && !($this?.CurrentStep?.IsAccepted)) {return true;}
return $this?.Owner != window._context.currentUser;
}
static Submit($this: any): any{}
static UpdateAmounts($this: any): any{$this.PayableAmount = $this?.PaymentOrders?.linq?.sum((po) => po?.PayableAmount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}